module.exports = __webpack_public_path__ + "assets/img/7b8faf06026fafdaf8e92b57d3d87ebd.png";